export const getStatusStyle = (status: string) => {
  switch (status) {
    case "Active":
      return { color: '#135200', bgColor: '#f6ffed', borderColor: '#b7eb8f' };
    case "Pending Invitation":
      return { color: '#614700', bgColor: '#fff7e6', borderColor: '#ffd591' };
    case "Terminated":
      return { color: '#6a1b1b', bgColor: '#fff1f0', borderColor: '#ffa39e' };
    default:
      return { color: '#595959', bgColor: '#fafafa', borderColor: '#d9d9d9' };
  }
};